"use strict";
/**
 * @fileoverview REST API Types Package - MIGRATION VERSION
 *
 * Central export point for all API type definitions used across the Spona application.
 * This version provides both NEW clean types and LEGACY API-prefixed types for gradual migration.
 *
 * @author Spona Team
 * @version 2.0.0-migration
 * @since 2025-10-22
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliverySettlementStatus = exports.PaymentStatus = exports.PaymentType = exports.EOrderSort = exports.DEFAULT_VALIDATION_RULES = exports.TimeGranularity = exports.AmountBasis = exports.OrderSort = exports.getVariantEurPrice = exports.getVariantRsdPrice = exports.getArticleRsdPrice = exports.getEurPrice = exports.getRsdPrice = exports.ClientPricingPlan = exports.NotificationType = exports.UserPermission = exports.UserRole = void 0;
var models_1 = require("./models");
Object.defineProperty(exports, "UserRole", { enumerable: true, get: function () { return models_1.UserRole; } });
Object.defineProperty(exports, "UserPermission", { enumerable: true, get: function () { return models_1.UserPermission; } });
Object.defineProperty(exports, "NotificationType", { enumerable: true, get: function () { return models_1.NotificationType; } });
Object.defineProperty(exports, "ClientPricingPlan", { enumerable: true, get: function () { return models_1.ClientPricingPlan; } });
var Article_js_1 = require("./models/Article.js");
Object.defineProperty(exports, "getRsdPrice", { enumerable: true, get: function () { return Article_js_1.getRsdPrice; } });
Object.defineProperty(exports, "getEurPrice", { enumerable: true, get: function () { return Article_js_1.getEurPrice; } });
Object.defineProperty(exports, "getArticleRsdPrice", { enumerable: true, get: function () { return Article_js_1.getArticleRsdPrice; } });
var index_js_1 = require("./models/index.js");
Object.defineProperty(exports, "getVariantRsdPrice", { enumerable: true, get: function () { return index_js_1.getVariantRsdPrice; } });
Object.defineProperty(exports, "getVariantEurPrice", { enumerable: true, get: function () { return index_js_1.getVariantEurPrice; } });
var orders_1 = require("./requests/orders");
Object.defineProperty(exports, "OrderSort", { enumerable: true, get: function () { return orders_1.OrderSort; } });
Object.defineProperty(exports, "AmountBasis", { enumerable: true, get: function () { return orders_1.AmountBasis; } });
var StatisticsRequest_1 = require("./requests/statistics/StatisticsRequest");
Object.defineProperty(exports, "TimeGranularity", { enumerable: true, get: function () { return StatisticsRequest_1.TimeGranularity; } });
var ProductImportTypes_js_1 = require("./products/ProductImportTypes.js");
Object.defineProperty(exports, "DEFAULT_VALIDATION_RULES", { enumerable: true, get: function () { return ProductImportTypes_js_1.DEFAULT_VALIDATION_RULES; } });
// ==================== LEGACY EXPORTS (unchanged API-prefixed types) ====================
// CUSTOMER TYPES
__exportStar(require("./customers/APIAddCustomerReqBody.js"), exports);
__exportStar(require("./customers/APICustomerResBody.js"), exports);
__exportStar(require("./customers/APIGetCustomersReqQuery.js"), exports);
__exportStar(require("./customers/APIGetCustomersResBody.js"), exports);
__exportStar(require("./customers/APIMigrateCustomersResBody.js"), exports);
__exportStar(require("./customers/APISearchCustomersReqQuery.js"), exports);
__exportStar(require("./customers/APIUpdateCustomerReqBody.js"), exports);
// ORDER TYPES
__exportStar(require("./orders/APIAddOrderReqBody.js"), exports);
__exportStar(require("./orders/APIAddOrderVersionReqBody.js"), exports);
__exportStar(require("./orders/APIGetOrderByOrderIdResBody.js"), exports);
__exportStar(require("./orders/APIGetOrderVersionsReqQuery.js"), exports);
__exportStar(require("./orders/APIGetMultipleOrdersByOrderNumberReqBody.js"), exports);
__exportStar(require("./orders/APIGetMultipleOrdersByOrderNumberResBody.js"), exports);
__exportStar(require("./orders/APIPostCommentReqBody.js"), exports);
__exportStar(require("./orders/APIPostCommentResBody.js"), exports);
__exportStar(require("./orders/APIGetOrdersByOrderNumberReqBody.js"), exports);
__exportStar(require("./orders/APIGetOrdersByOrderNumberResBody.js"), exports);
__exportStar(require("./orders/APISearchOrdersReqBody.js"), exports);
var APISearchOrdersReqBody_js_1 = require("./orders/APISearchOrdersReqBody.js");
Object.defineProperty(exports, "EOrderSort", { enumerable: true, get: function () { return APISearchOrdersReqBody_js_1.EOrderSort; } });
__exportStar(require("./orders/APISearchOrdersResBody.js"), exports);
__exportStar(require("./orders/APIUpdateStateReqBody.js"), exports);
var PaymentType_js_1 = require("./CommonTypes/PaymentType.js");
Object.defineProperty(exports, "PaymentType", { enumerable: true, get: function () { return PaymentType_js_1.PaymentType; } });
var PaymentStatus_js_1 = require("./CommonTypes/PaymentStatus.js");
Object.defineProperty(exports, "PaymentStatus", { enumerable: true, get: function () { return PaymentStatus_js_1.PaymentStatus; } });
var DeliverySettlementStatus_js_1 = require("./CommonTypes/DeliverySettlementStatus.js");
Object.defineProperty(exports, "DeliverySettlementStatus", { enumerable: true, get: function () { return DeliverySettlementStatus_js_1.DeliverySettlementStatus; } });
// SETTINGS TYPES
__exportStar(require("./settings/APIGetAppSettingsResBody.js"), exports);
// COMMON TYPES
__exportStar(require("./common/HttpError.js"), exports);
__exportStar(require("./common/APIResponse.js"), exports);
// USER TYPES
__exportStar(require("./users/APIGetUserResBody.js"), exports);
__exportStar(require("./users/APIAddUserReqBody.js"), exports);
__exportStar(require("./users/APIUpdateUserReqBody.js"), exports);
// COMMON TYPES (shared across resources)
__exportStar(require("./common/APISetActiveReqBody.js"), exports);
__exportStar(require("./common/APIDeleteReqBody.js"), exports);
// Group types
__exportStar(require("./groups/index.js"), exports);
